export default __webpack_public_path__ + "static/media/Bomb brothers icon.b19fb1ca.png";